import React from 'react';
import { useNavigate } from 'react-router-dom';
import InternalChat from '../../../components/InternalChat';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiArrowLeft, FiMessageSquare } = FiIcons;

const SuperAdminMessages = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-4">
              <button 
                onClick={() => navigate('/superadmin')} 
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <SafeIcon icon={FiArrowLeft} />
              </button>
              <div>
                <h1 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                  <SafeIcon icon={FiMessageSquare} className="text-blue-600" />
                  Meldingssenter
                </h1>
                <p className="text-sm text-gray-500">Kommuniser med dine partnere</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <InternalChat currentUserType="superadmin" />
      </div>
    </div>
  );
};

export default SuperAdminMessages;